module.exports = __webpack_public_path__ + "img/10b)(Schlosshotel Velden)Montage von über 100 Suiten.jpg";